import { Response } from '@angular/http';
import { saveAs } from 'file-saver/FileSaver';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { zip } from 'rxjs/observable/zip';
import { ApiRequestOptions } from '../../../core/services/api/request-options';
import { AccountObjectApiFacade } from '../account-object/account-object.api-facade';
import { Report } from './report.model';

export class ReportApiFacade extends AccountObjectApiFacade<Report> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Report> {
        return this.GET(`/accounts/${accountId}/reports/${id}`, options)
            .map(object => new Report(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<Report>> {
        return this.CGET(`/accounts/${accountId}/reports`, options)
            .map(objects => objects.map(object => new Report(object)));
    }

    getByJob(
        accountId: string,
        jobId: string,
        options?: ApiRequestOptions
    ): Observable<Array<Report>> {
        return this.appFacade.objects.job.api.get(accountId, jobId, options)
            .concatMap(job => {
                if (job.reports.length === 0) {
                    return of([]);
                }
                return zip(...job.reports.map(id => this.get(accountId, id)));
            })
            .map(reports => reports.map(object => new Report(object)));
    }

    getReportContent(accountId: string, reportId: string): Observable<any> {
        return this.api.getReportContent(accountId, reportId);
    }

    /**
     * Downloads a report from the api and initialises the saveAs dialog.
     *
     * @param accountId {string}
     * @param reportId {string}
     * @param filename {string}
     */
    async downloadReportDesktop(
        accountId: string,
        reportId: string,
        filename: string
    ): Promise<any> {
        const blob = await this.getReportContent(accountId, reportId).toPromise();
        saveAs(blob, filename);
    }

    remove(
        accountId: string,
        id: string,
        options?: ApiRequestOptions
    ): Observable<Response> {
        return this.DELETE(
            `/accounts/${accountId}/reports/${id}`,
            options
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report/report.api-facade.ts